import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import history from '../routes/history';
import LoaderReducer from './LoaderReducer';
import AuthReducer from './AuthReducer';
import NegotiationReducer from './NegotiationReducer';
import HomeReducer from './HomeReducer';

export default combineReducers({
  router: connectRouter(history),
  loader: LoaderReducer,
  auth: AuthReducer,
  negotiationReducer: NegotiationReducer,
  homeReducer: HomeReducer
});
